/**
 * Auth.js requires OAuth sign-in to be initiated via a POST with a CSRF token
 * (GET /api/auth/signin/:provider is intentionally blocked by the library).
 * These helpers fetch the CSRF token and submit the form programmatically.
 */

async function fetchCsrfToken(): Promise<string> {
  const res = await fetch("/api/auth/csrf");
  const data = (await res.json()) as { csrfToken: string };
  return data.csrfToken;
}

function postForm(action: string, fields: Record<string, string>) {
  const form = document.createElement("form");
  form.method = "POST";
  form.action = action;
  for (const [name, value] of Object.entries(fields)) {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }
  document.body.appendChild(form);
  form.submit();
}

export async function signInWithGoogle(callbackUrl = "/") {
  const csrfToken = await fetchCsrfToken();
  postForm("/api/auth/signin/google", { csrfToken, callbackUrl });
}

export async function signOut(callbackUrl = "/") {
  const csrfToken = await fetchCsrfToken();
  postForm("/api/auth/signout", { csrfToken, callbackUrl });
}
